/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Model_FranchiseeInputs */

const cs_franchise_model_franchisee = /** @type {(inputs: Franchise_Model_FranchiseeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franšízant`)
};

const en_franchise_model_franchisee = /** @type {(inputs: Franchise_Model_FranchiseeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchisee`)
};

/**
* | output |
* | --- |
* | "Franchisee" |
*
* @param {Franchise_Model_FranchiseeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_model_franchisee = /** @type {((inputs?: Franchise_Model_FranchiseeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Model_FranchiseeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_model_franchisee(inputs)
	return cs_franchise_model_franchisee(inputs)
});